//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"Expression",0,"Expression",0],[0,"OriginalValue",0,0],[0,"SliderLimit",1,0],[0,"StepScale",1,0],[0,"StepValue",1,0]],[[[],"StepUp",{},0,0],[[],"StepDown",{},0,0],[["inContinuousOp"],"Update",{},1,0],[[],"UpdateOnExpression",{},0,0]],[]];
SPLM.Features.StepExpressionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StepExpressionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;